import _ from 'lodash';
import IApplicationState from 'app/types/state';
import { parseAmount, toTitleCase, friendlyDate } from 'app/utils/parsers';

function mapSelect(refunds, n) {
  const sa = refunds.refundsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getRefundsByIdInSelectFormat(refunds): any {
  return _.map(refunds.refundIds, (n) => mapSelect(refunds, n));
}

export function getCurrentRefund(state: IApplicationState): any {
  if (
    state.refunds.refundsById !== undefined
    && state.refunds.currentRefundId !== undefined
  ) {
    const findRefund = state.refunds.refundsById[
      state.refunds.currentRefundId
    ];
    const currentRefund = {
      ...findRefund,
    };

    return currentRefund;
  }
  return {};
}

export function getCurrentFormRefund(state: IApplicationState) {
  return {
    ...getCurrentRefund(state),
    ...state.refunds.requestedData,
  };
}

export function getRefunds(state: IApplicationState): any {
  return {
    ...state.refunds,
    currentRefund: {
      ...getCurrentRefund(state),
    },
  };
}

export function getRefundsByTeamId(state, teamId): any {
  if (state.refunds.refundsById !== undefined && teamId != null) {
    return _.filter(state.refunds.refundsById, { teamId });
  }
  return {};
}

export function getRefundsByIds(refundsById, tagIds): any {
  if (refundsById !== undefined && tagIds != null) {
    return _.pick(refundsById, tagIds);
  }
  return {};
}

export function getRefundIdsByTeamId(state, teamId): any {
  if (state.refunds.refundsById !== undefined && teamId != null) {
    const filtered = _.filter(state.refunds.refundsById, {
      teamId,
    });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}

function parseRefundStatusText(refund) {
  let parsedText = _.capitalize(refund.status);
  if (_.isEmpty(refund.status)) {
    parsedText = 'Pending';
  }
  return parsedText;
}

function parseRefundStatusColour(refund) {
  let parsedColour = 'grey';
  if (refund.status === 'completed') {
    parsedColour = 'green';
  }
  return parsedColour;
}

function parseRefundStatus(status) {
  const statuses = [];
  const colour = parseRefundStatusColour(status);
  const text = parseRefundStatusText(status);

  statuses.push({ colour, text });

  return statuses;
}

export function getRefundSummary(refund): any {
  const refundSummary = {
    id: refund.id,
    status: parseRefundStatus(refund.status),
    name: refund.name,
    createdAt: friendlyDate(refund.createdAt),
  };
  return refundSummary;
}
